import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SearchIcon from "assets/svg/SearchIcon";
import {
  Heading,
  SearchWrapper,
  RightSection
} from "styles/pages/invoice";
import InputLabel from "@mui/material/InputLabel";
import DropDown from "./DropDown";
import InvoiceSearchTypeahead from "./InvoiceSearchTypeahead"
import FormControl from "@mui/material/FormControl";
import * as moment from "moment";
import { FORMAT } from "utils/dateOfBirthValidation";
import { SelectWrapper } from "styles/components/FilterModal";
import DatePicker from "./DatePicker";
import MultiSelect from "./MultiSelect";
import { useText } from "locales/useGetText";
// Component Start
const optionForAllSelect = { label: "All", value: "All" }

const HeadingSection = (props) => {
  const navigate = useNavigate();
  const locale = useText("invoices");
  const loggedInUserInfo = JSON.parse(localStorage.getItem('loggedInUserData'))
  const { filter, handleFilterChange, setFilter, locations: defaultLocations } = props;
  const [selectedFilter, setSlectedFilter] = useState("")
  const [invoiceFilter, setInvoiceFilter] = useState("")
  const [searchVal, setSearchVal] = useState("")

  const propsLocations = (defaultLocations ? defaultLocations : [])
  const conditionaLocationsWithAllOption = (defaultLocations && defaultLocations.length > 1) ? [optionForAllSelect, ...propsLocations] : [...propsLocations]
  const [locations, setLocations] = useState(conditionaLocationsWithAllOption)
  const [allLocationsValue, setAllLocationsValue] = useState([])
  const [optionAllSelected, setOptionAllSelected] = useState(true)

  useEffect(() => {
    setLocations(conditionaLocationsWithAllOption)
    setAllLocationsValue(propsLocations.map(item => item.value))
  }, [defaultLocations])

  useEffect(() => {
    if (!loggedInUserInfo?.token) {
      navigate("/");
    } else {
      setMultiSelectVal(locations && locations[0])
    }
  }, [locations]);
  let filterDropDown = [
    // {
    //   label: "Sort By",
    //   value: ""
    // },
    {
      label: locale("all"),
      value: null
    },
    {
      label: locale("byOrder"),
      value: "DAILY"
    },
    {
      label: locale("weekly"),
      value: "WEEKLY"
    },
    {
      label: locale("monthly"),
      value: "MONTHLY"
    },
  ]
  let invoiceDropDown = [
    // {
    //   label: "Invoice Status",
    //   value: ""
    // },
    {
      label: locale("all"),
      value: null
    },
    {
      label: locale("paid"),
      value: "PAID"
    },
    {
      label: locale("unpaid"),
      value: "UNPAID"
    }
  ]

  //Date
  let toDate = new Date();
  let fromDate = new Date();
  const [requestedToDate, setRequestedToDate] = useState(
    toDate.toISOString().substr(0, 10)
  );
  const [requestedFromDate, setRequestedFromDate] = useState(
    fromDate.toISOString().substr(0, 10)
  );
  const [searchTextState, setSearchTextState] = useState("");
  let mainLocations = locations && locations[0]
  const [multiSelectVal, setMultiSelectVal] = useState([mainLocations]);

  let defaultToDate = moment(new Date()).format(FORMAT)
  const [defaultToDateState, setDefaultToDateState] = useState(defaultToDate);

  let defaultfromDate = moment(new Date().setMonth(new Date().getMonth() - 6)).format(FORMAT)
  const [defaultFromState, setDefaultFromState] = useState(defaultfromDate);
  return (
    <Heading>
      {/* RightSection  */}
      <RightSection>
        {/* SortBy */}
        <FormControl
          variant="standard"
          sx={{ width: 130 }}
        >
          <InputLabel>{locale("sortBy")}</InputLabel>
          <DropDown
            name="filterDropDown"
            className="responsive"
            data={filterDropDown}
            searchDropDown={selectedFilter}
            searchable={true}
            placeholder={locale("sortBy")}
            onChangeHandler={(val) => {
              setSlectedFilter(val)
              if (val) {
                if (searchVal) {
                  handleFilterChange("searchBy", "")
                  handleFilterChange("invoiceSchedule", val)
                } else {
                  handleFilterChange("invoiceSchedule", val)
                }
              } else {
                handleFilterChange("invoiceSchedule", val, true)
              }


            }}
          />
        </FormControl>
        <SelectWrapper className="all-invoice-date-picker">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-end",
              gap: "10px",
              width: 330,
            }}
          >
            <DatePicker
              className="responsive"
              name="fromDate"
              placeholderText=""
              maxDOBirth={defaultToDateState}
              value={defaultFromState}
              callBackFun={(date) => {
                setFilter({
                  ...filter,
                  findAll: false,
                  ["fromDate"]: new Date(date) / 1000,
                });
                setDefaultFromState(moment(date).format("MM/DD/YYYY"))
                setRequestedFromDate(moment(date).format("MM/DD/YYYY"));
              }}
            />
            <DatePicker
              name="toDate"
              className="responsive"
              placeholderText=""
              minDOBirth={defaultFromState}
              value={defaultToDate}
              callBackFun={(date) => {
                let nDate = moment(date).add(1, 'days');
                setFilter({
                  ...filter,
                  searchBy: searchVal,
                  findAll: false,
                  ["toDate"]: new Date(nDate) / 1000,
                });
                setDefaultToDateState(moment(date).add(1, 'days').format("MM/DD/YYYY"))
                setRequestedToDate(moment(date).add(1, 'days').format("MM/DD/YYYY"));
              }}
            />
          </div>
        </SelectWrapper>
        <FormControl
          variant="standard"
          sx={{ width: 180 }}
        >
          <InputLabel>{locale("invoiceStatus")}</InputLabel>
          <DropDown
            className="responsive"
            name="filterDropDown"
            data={invoiceDropDown}
            searchDropDown={invoiceFilter}
            placeholder={locale("invoiceStatus")}
            searchable={true}
            onChangeHandler={(val) => {
              setInvoiceFilter(val)
              if (val) {
                if (searchVal) {
                  handleFilterChange("searchBy", "")
                  handleFilterChange("status", val)
                } else {
                  handleFilterChange("status", val)
                }
              } else {
                handleFilterChange("status", val, true)
              }

            }}
          />
        </FormControl>

        <MultiSelect
          data={locations}
          placeholder={locale("selectLocation")}
          multiSelectVal={multiSelectVal}
          defaultValueArr={multiSelectVal}
          setMultiSelectVal={(multiSelectVal) => {
            let result = multiSelectVal.map(item => item.value);
            if (result.length < 1) {
              handleFilterChange("locations", allLocationsValue)
              setMultiSelectVal([])
              setOptionAllSelected(false)
            }
            else {
              if (result.indexOf("All") > -1 && !optionAllSelected) {
                handleFilterChange("locations", allLocationsValue)
                setMultiSelectVal(optionForAllSelect)
                setOptionAllSelected(!optionAllSelected)
              } else {
                const selectCurrent = multiSelectVal.filter(item => item.value !== "All")
                handleFilterChange("locations", selectCurrent.map(item => item.value))
                setMultiSelectVal(selectCurrent)
                setOptionAllSelected(false)
              }
            }
          }}
          multi={true}
        />
        <SearchWrapper className="responsive">
          <InvoiceSearchTypeahead
            placeholder={locale("search")}
            focusOnShow={false}
            filterBy="title"
            containerStyle="makeSearch"
            color="#074269"
            backgroundColor="#01b3ff"
            callBack={(val) => {
              setSearchVal(val)
              handleFilterChange("searchBy", val)
            }}
          />
          <SearchIcon className="search-icon" />
        </SearchWrapper>
      </RightSection>
    </Heading>
  );
};

export default HeadingSection;
